
<template>
  <div class="title" style="margin: auto;justify-content: center">
    <div class="content-title">
      <div class="title-head">
        <div class="title-cn">客户资产与消费&amp;还款分析报告</div>
      </div>
    </div>
    <div class="title-foot1">
      <div class="bv-title">
        <span class="bv-title-cn">上传异常信息</span>
        <br>
        <span class="bv-title-en">BILL VERIFICATION</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="ErrLogColumns" :data="dataMap.errorLog"></Table>
      </div>
      <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">本界面旨在提示用户上传信息不符合规则，若提示用户姓名和账单姓名不符，请重新上传。
          <br>
          解析异常等异常信息请联系管理员</span>
      </div>
    </div>
    </div>
</template>
<script>

export default {
  name: 'content-error',
  props: {
    dataMap: {
      type: Object
    }
  },
  data () {
    return {
      ErrLogColumns:
        [{
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '名字')
            ])
          }
        }, {
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '身份证号')
            ])
          }
        }, {
          key: 'uploadTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '上传时间')
            ])
          }
        }, {
          key: 'errorType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-folder'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '异常类型')
            ])
          }
        }, {
          key: 'errorMsg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '处理意见')
            ])
          }
        }]
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap)
  },
  methods: {
    setData (dataMap) {
      this.dataMap = dataMap
    }
  }
}
</script>
